import {gsap} from 'gsap';

import {Status} from '../../Config/Status.js';

const Introduction = {
  instance : {},
  phase01() {
    const wrapElm = document.getElementById('js-animationPhase01');
    const targetElm = document.getElementById('js-animationPhase01_Object');
    const offset = targetElm.getBoundingClientRect().height / 2;
    this.instance.phase01 = gsap.timeline();
    this.instance.phase01.to(targetElm, {
      x: 0,
      scrollTrigger: {
        trigger: wrapElm,
        markers: false,
        start: `top+=${offset}px center`,
        end: `bottom+=${Status.winHeight*2 - offset}px center`,
        pin: true,
      }
    })
  },
  phase02() {
    const wrapElm = document.getElementById('js-animationPhase02');
    const fadeInElm = document.getElementById('js-animationPhase02_Object');
    const fadeOutElm = document.getElementById('js-animationPhase01_Object');
    this.instance.phase02 = gsap.timeline();
    this.instance.phase02.to(wrapElm, {
      scrollTrigger: {
        trigger: wrapElm,
        markers: false,
        start: `top top`,
        end: `bottom bottom-=${Status.winHeight*3}px`,
        pin: true,
        scrub: true,
        onEnter: () => {
          gsap.timeline().to(fadeOutElm, {
            opacity: 0,
            duration: 0.3,
          }).to(fadeInElm, {
            opacity: 1,
            duration: 0.3,
          });
        },
        onLeaveBack: () => {
          gsap.timeline().to(fadeInElm, {
            opacity: 0,
            duration: 0.3,
          }).to(fadeOutElm, {
            opacity: 1,
            duration: 0.3,
          });
        },
      }
    });
  },
  phase03() {
    const wrapElm = document.getElementById('js-animationPhase03');
    const stickyElm = document.getElementById('js-animationPhase03_ObjectFrame');
    const targetElms = document.getElementsByClassName('js-animationPhase03_Object');
    gsap.set(targetElms, {
      opacity: 0,
      scale: 1.25,
    });
    let current = 0;
    this.instance.phase03 = gsap.timeline();
    this.instance.phase03.to(stickyElm, {
      scrollTrigger: {
        trigger: wrapElm,
        markers: false,
        start: `top top`,
        end: `bottom bottom`,
        pin: true,
        scrub: true,
        onUpdate: (self) => {
          const interval = 1 / targetElms.length;
          const index = Math.floor(self.progress / interval);
          if(0 < index) {
            if(index - current > 0) {
              const targetElm = targetElms[index - 1];
              gsap.to(targetElm, {
                opacity: 1,
                scale: 1,
                duration: 0.3,
              });
              current = index;
            } else if(index - current < 0) {
              const targetElm = targetElms[index];
              gsap.to(targetElm, {
                opacity: 0,
                scale: 1.25,
                duration: 0.3,
              });
              current = index;
            }
          } else {
            gsap.to(targetElms[0], {
              opacity: 0,
              scale: 1.25,
              duration: 0.3,
            });
            current = 0;
          }
        },
        onLeave: () => {
          for(let i = 0; i < targetElms.length; i++) {
            gsap.to(targetElms[i], {
              opacity: 1,
              scale: 1,
              duration: 0.3,
            });
          }
        },
        onLeaveBack: () => {
          for(let i = 0; i < targetElms.length; i++) {
            gsap.to(targetElms[i], {
              opacity: 0,
              scale: 1.25,
              duration: 0.3,
            });
          }
        },
      }
    });
  }
}

export default Introduction;